import { render, staticRenderFns } from "./quesInstru6.vue?vue&type=template&id=f39d5030"
import script from "./quesInstru6.vue?vue&type=script&lang=js"
export * from "./quesInstru6.vue?vue&type=script&lang=js"
import style0 from "./quesInstru6.vue?vue&type=style&index=0&id=f39d5030&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports